<template>
  <div v-if="visible" id="tab-hbl2">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="command1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-show="Boolean(form.docType)"
            no="originalPrint"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}</el-button>
          <el-button
            v-show="form.state==2"
            no="onSubmitStatEvent"
            type="primary"
            @click="unlock"
          >{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button
            no="showAddressFormatDialog"
            :disabled="readonly||!form.uuid"
            type="primary"
            @click="showAddressFormatDialog"
          >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
          <el-dropdown
            v-if="!OpenXHQDocumentCenter"
            no="command2"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{ $t('SeaExport.InviteToChecktheBL') }}</el-dropdown-item>
              <el-dropdown-item v-permission="['button_M/HBL_confirmBL']" :command="$t('SeaExport.ConfirmChecking')">{{ $t('SeaExport.ConfirmChecking') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_M/HBL_identification'])" :command="$t('SeaExport.IdentificationList')">{{ $t('SeaExport.IdentificationList') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{ $t('SeaExport.CheckingHistory') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.UploadGuarantee')">{{ $t('SeaExport.UploadGuarantee') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-menu
            v-if="OpenXHQDocumentCenter"
            :class="isEdit||!form.uuid?'is-disabled not-click':''"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="vertical-align: top"
            @select="XHQDocumentCenterSelectHandler"
          >
            <el-submenu index="index">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.InviteToChecktheBL') }}</span>
              <el-menu-item index="InviteToChecktheBL">{{ $t('SeaExport.InviteToChecktheBL') }}</el-menu-item>
              <el-submenu :index="$t('SeaExport.UploadCustomerFiles')">
                <template slot="title">{{ $t('SeaExport.UploadCustomerFiles') }}</template>
                <el-menu-item index="BillOfLadingConfirmationDocument">{{ $t('Clearing.BillOfLadingConfirmationDocument') }}</el-menu-item>
                <el-menu-item index="CustomerSelfIssuedFiles">{{ $t('SeaExport.CustomerSelfIssuedFiles') }}</el-menu-item>
                <el-menu-item v-if="ToExoSystemJYD" index="OriginBillOfLading">{{ $t('SeaExport.OriginBillOfLading') }}</el-menu-item>
                <el-menu-item index="ShippingOrder">{{ $t('SeaExport.ShippingOrder') }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-if="$checkPermission(['button_M/HBL_identification'])" index="IdentificationList">{{ $t('SeaExport.IdentificationList') }}</el-menu-item>
              <el-menu-item index="CheckTheBLLog">{{ $t('SeaExport.CheckTheBLLog') }}</el-menu-item>
              <el-menu-item index="ConfirmChecking">{{ $t('SeaExport.ConfirmChecking') }}</el-menu-item>
              <el-menu-item index="UploadGuarantee">{{ $t('SeaExport.UploadGuarantee') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <!-- 对单链接-->
          <el-button v-if="OpenXHQDocumentCenter && ToExoSystemJYD" :disabled="isEdit||!form.uuid" no="CustomerToOrder" type="primary" @click="onOpenDocLink(0)">{{ $t('SeaExport.CustomerToOrder') }}</el-button>
          <el-button v-if="OpenXHQDocumentCenter && ToExoSystemJYD" :disabled="isEdit||!form.uuid" no="DesignatedGoodsToBillOfLading" type="primary" @click="onOpenDocLink(1)">{{ $t('SeaExport.DesignatedGoodsToBillOfLading') }}</el-button>
          <el-button
            v-if="OpenXHQDocumentCenter"
            :disabled="isEdit"
            no="updateBillInfo"
            type="primary"
            @click="pm.updateBillInfo()"
          >{{ $t('SeaExport.ConfirmationBillOfLading') }}</el-button>
          <el-checkbox
            :value="form.state===2"
            :disabled="true"
            style="margin-left: 20px;"
          >{{ $t('SeaExport.Locked') }}</el-checkbox>
          <el-checkbox
            v-model="form.oversea"
            no="oversea"
            :disabled="readonly"
            style="margin-left: -20px"
          >{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam1"
            no="printParam1"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="pm.changeSeaeq()"
          >Part of</el-checkbox>
          <el-checkbox v-model="form.printParam2" no="printParam2" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="printParam3"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="val=>{pm.changeContainer(val)}"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
          <el-checkbox v-model="chkConsolidationClosed" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.AFRTheLastBill') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease"
            :value="form.customerSelfRelease===1"
            :disabled="readonly"
            @input="isCustomerSelfRelease"
          >{{ $t('SeaExport.CustomerSelfRelease') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease2"
            :value="form.customerSelfRelease===2"
            :disabled="readonly"
            @input="isCompanySelfRelease"
          >{{ $t('SeaExport.CompanySelfRelease') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form label-width="70px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
            <el-form-item class="auto-width">
              <span slot="label" :class="variableCss.shipperLine">{{ $t('SeaExport.Shipper') }}</span>
              <div style="display: flex">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="shipperCode"
                  v-model="form.shipperCode"
                  :disabled="readonly"
                  no="shipperCode"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="shipperId"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{ shipper: true, active: true }"
                  filterable
                  :default-value="form.shipperId||''"
                  tag-name="englishName"
                  style="flex:1;"
                  @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
                />
                <el-button type="primary" :disabled="readonly" style="margin-left:6px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item v-for="count in 7" :key="'shipperLine'+count" :class="'auto-width '+ getClass('shipperLine',count)">
              <cargo-input
                :ref="'shipperLine'+count"
                v-model="form['shipperLine'+count]"
                :disabled="readonly"
                :no="'shipperLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showShipperDialog"
                @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label" :class="variableCss.consigneeLine">{{ $t('SeaExport.Consignee') }}</span>
              <div style="display: flex">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="consigneeCode"
                  v-model="form.consigneeCode"
                  :disabled="readonly"
                  no="consigneeCode"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="consigneeId"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{ consignee: true, active: true }"
                  filterable
                  :default-value="form.consigneeId||''"
                  tag-name="englishName"
                  style="flex:1;"
                  @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
                />
                <el-button no="onClear2" type="primary" :disabled="readonly" style="margin-left:6px" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'consigneeLine'+count"
              :class="'auto-width ' + getClass('consigneeLine',count)"
            >
              <cargo-input
                :ref="'consigneeLine'+count"
                v-model="form['consigneeLine'+count]"
                :disabled="readonly"
                :no="'consigneeLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showConsigneeDialog"
                @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label" :class="variableCss.notifyLine">{{ $t('SeaExport.NotifyParty') }}</span>
              <div>
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="notifyCode"
                  v-model="form.notifyCode"
                  :disabled="readonly"
                  no="notifyCode"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="notifyId"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{ notify: true, active: true }"
                  filterable
                  :default-value="form.notifyId||''"
                  tag-name="englishName"
                  @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
                />
                <div style="margin-top: 5px">
                  <el-button no="onClear3" type="primary" :disabled="readonly" style="min-width: 50px" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                  <el-button no="onCopy_consignee" type="primary":disabled="readonly" style="margin-left:5px;" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'notifyLine'+count"
              :class="'auto-width ' + getClass('notifyLine',count)"
            >
              <cargo-input
                :ref="'notifyLine'+count"
                v-model="form['notifyLine'+count]"
                :disabled="readonly"
                :no="'notifyLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showNotifyDialog"
                @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label" style="color:#404144!important;">{{ $t('SeaExport.AgentInfo') }}</span>
              <div style="text-align: right">
                <el-button no="onClear4" type="primary" :disabled="readonly" style="min-width: 50px;margin-right: 5px;" @click="pm.onClear(4)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-dropdown
                  no="command3"
                  :disabled="readonly"
                  style="margin-top: 5px;"
                  :class="readonly?'not-click':''"
                  split-button
                  type="primary"
                  @click="commandHandle(command3)"
                  @command="p=>{command3=p;commandHandle(command3)}"
                >
                  {{ command3 }}
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                    <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'agentPartyLine'+count"
              :class="'auto-width ' + getClass('agentPartyLine',count)"
            >
              <cargo-input
                :ref="'agentPartyLine'+count"
                v-model="form['agentPartyLine'+count]"
                :disabled="readonly"
                :no="'agentPartyLine'+count"
                :auto-uppercase="isUppercase"
                :use-read-only="true"
                @dblclick.native="showAgentPartyDialog"
                @change="()=>wrapAddr(form,'agentPartyLine'+count,count+1 > 6 ? null :'agentPartyLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <span style="color:#404144!important">ALSO NOTIFY</span>
            </el-form-item>
            <el-form-item class="auto-width">
              <cargo-rich-textarea
                v-model="form.alsoNotify"
                no="alsoNotify"
                :disabled="readonly"
                :text-chars="0"
                wrap-symbol="r"
                auto-half-word
                auto-uppercase
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},true,{warningCount:45,autoUppercase:true,autoHalfWord:true})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="125px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
            <el-form-item :label="$t('SeaExport.NumberOfPackagesOnBl')" :class="variableCss.quantity">
              <auto-number-input
                v-model="form.quantity"
                no="quantity"
                :precision="0"
                :min="0"
                :disabled="!isJydEditJobFields"
                @change="pm.quantity_Change()"
                @blur="hblNbr2Change"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')" :class="variableCss.packing">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.packing"
                style="width:100%;"
                @parentCallBack="p=>{pm.packing_Change(p)}"
              /> -->
              <cargo-packing-select
                no="packing"
                :default-value="form.packing"
                @change="p => {pm.packing_Change(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Pieces2')" :class="variableCss.insideQuantity">
              <auto-number-input
                v-model="form.insideQuantity"
                no="insideQuantity"
                :precision="0"
                :min="0"
                @change="p=>{hblNbr2Change(p);refreshInsideQuantityCharge(p);} "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PiecesType2')" :class="variableCss.insidePacking">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.insidePacking"
                style="width:100%;"
                @parentCallBack="p=>{form.insidePacking=p.value}"
              /> -->
              <cargo-packing-select
                no="insidePacking"
                :default-value="form.insidePacking"
                @change="p => {form.insidePacking=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Weight')" :class="variableCss.weight">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <el-input-number
                  v-model="form.weight"
                  no="weight"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  :disabled="!isJydEditJobFields"
                  style="flex: 1"
                  @change="p=>{hblNbr2Change(p);refreshWeightCharge(p);}"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Cubage')" :class="variableCss.cubage">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <el-input-number
                  v-model="form.cubage"
                  no="cubage"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  :disabled="!isJydEditJobFields"
                  style="flex: 1"
                  @change="p=>{hblNbr2Change();refreshCubageCharge(p);}"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <el-input-number
                  v-model="form.chargeWeight"
                  no="chargeWeight"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  style="flex: 1"
                  @change="p=>{hblNbr2Change();refreshChargeWeightCharge(p);}"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item :class="'auto-width '+variableCss.cargoEnglishName">
              <div style="display: flex;justify-content: flex-end">
                <el-button v-if="job.typeHBL===BillType.MERGE_BILL_TYPE.code" no="getCargoEnglishNameFromMergeJob" type="primary" @click="pm.getCargoEnglishNameFromMergeJob()">{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMergeJob') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" :class="'auto-width '+variableCss.cargoEnglishName">
              <cargo-rich-textarea
                ref="cargoTextarea1"
                v-model="form.cargoEnglishName"
                no="cargoTextarea1"
                :disabled="!isEdit"
                :text-chars="0"
                :warning-count="-1"
                wrap-symbol="r"
                :auto-uppercase="isUppercaseByConfig"
                auto-half-word
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
              />
            </el-form-item>
            <el-form-item label-width="0" :class="'auto-width '+variableCss.mark">
              <div style="display: flex;justify-content: flex-end">
                <el-button v-if="job.typeHBL===BillType.MERGE_BILL_TYPE.code" no="getMarkFromMergeJob" type="primary" @click="pm.getMarkFromMergeJob()">{{ $t('SeaExport.CopyMarkFromMergeJob') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')" :class="'auto-width '+variableCss.mark">
              <cargo-rich-textarea
                ref="cargoTextarea2"
                v-model="form.mark"
                no="cargoTextarea2"
                :text-chars="0"
                :warning-count="-1"
                wrap-symbol="r"
                :auto-uppercase="isUppercaseByConfig"
                auto-half-word
                :disabled="!isEdit"
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="auto-width">
              <el-input v-model="form.quantitySum" :disabled="true" no="quantitySum" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
            <el-form-item label="HB/L NO2.">
              <el-input v-model="form.hblNbr2" no="hblNbr2" @input="hblNbr2Change" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehouseNo')">
              <el-input v-model="form.warehouseNo" no="warehouseNo" @change="hblNbr2Change" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.RelatedMbl')">
              <cargo-combo-box
                v-model="form.mblId"
                no="mblId"
                :disabled="readonly&&splitOrder.rowData.length>0"
                :options="pm.joinMBLs"
                label-field="mblNbr2"
                value-field="uuid"
                :need-old-value="true"
                :forbid-values="['']"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HBLBillOfLadingNum')">
              <el-input v-model="form.serialNo" no="serialNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Vessel')">
              <cargo-advance-select
                no="vessel"
                :disabled="readonly||!pm._lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_Vessel"
                filterable
                clearable
                :allow-create="pm._allowEditingVessel"
                :default-value="job.vessel"
                style="width:100%;"
                @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Voyage')">
              <el-select
                ref="voyageFlight"
                v-model="job.voyageFlight"
                no="voyageFlight"
                :disabled="readonly||!pm._lclslaveEnabled||pm.editVoyageMode!==1"
                filterable
                allow-create
                @focus="pm.txtVoyagefocusInHandler()"
                @blur="pm.txtVoyagefocusOutHandler()"
              >
                <el-option
                  v-for="(item,index) in pm._voyages"
                  :key="index"
                  :label="item.voyageNo"
                  :value="item.voyageNo"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfDeparture')">
              <el-input :value="sailingDate" :disabled="true" no="sailingDate" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptOnBl')" :class="variableCss.dispatchingPlace">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode||''"
                tag-name="englishName"
                no="1"
                @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
              />
              <el-input v-model="form.dispatchingPlace" no="dispatchingPlace" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')" :class="variableCss.loadingPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="2"
                @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
              />
              <el-input v-model="form.loadingPort" no="loadingPort" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')" :class="variableCss.dischargingPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="3"
                @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
              />
              <el-input v-model="form.dischargingPort" no="dischargingPort" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')" :class="variableCss.destinationPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode||''"
                tag-name="englishName"
                no="4"
                @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
              />
              <el-input v-model="form.destinationPort" no="destinationPort" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlFinalDestination')">
              <el-input v-model="form.destinationPlace" no="destinationPlace" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MethodOfHblPayment')">
              <cargo-advance-select
                no="paymentTerm"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :default-value="form.paymentTerm"
                :allow-create="true"
                style="width:100%;"
                @parentCallBack="p=>{pm.paymentSelectHblChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfHblPayment2')">
              <el-input v-model="form.paymentPlaceBL" no="paymentPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <el-input v-model="form.freightTermHBL" no="freightTermHBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NoOfOriginalBls')" :class="variableCss.BLNumber">
              <el-input v-model="form.blNumber" no="blNumber" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
              <el-input v-model="form.signPlaceBL" no="signPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfIssue')">
              <el-date-picker v-model="form.signDateBL" no="signDateBL" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlRemarks')" :class="variableCss.remarks">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HsCode')">
              <el-input
                v-model="form.hsCode"
                no="hsCode"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CheckingQuestions')">
              <el-input
                v-model="form.customerCfmException"
                no="customerCfmException"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CheckingQuestions'),form.customerCfmException,val=>{form.customerCfmException=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form label-width="125px" label-position="right">
            <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
            <el-form-item
              v-show="job.typeHBL===BillType.SPLIT_BILL_TYPE.code"
              label-width="0"
              class="auto-width"
            >
              <cargo-ag-grid
                no="OtherInfo"
                :grid-options="splitOrder.gridOptions"
                :column-defs="splitOrder.columnDefs"
                :row-data="splitOrderFinalRowData"
                :auto-fit-content="false"
                style="width:100%;height:200px"
                @gridReady="splitOrderGridReady"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button no="onAddCargoDoc2" type="primary" :disabled="readonly" @click="pm.onAddCargoDoc2(true)">{{ $t('SeaExport.Add') }}</el-button>
                  <el-button no="onRemoveCargoDoc" type="danger" :disabled="readonly" @click="pm.onRemoveCargoDoc()">{{ $t('SeaExport.Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              v-show="job.typeHBL===BillType.MERGE_BILL_TYPE.code"
              label-width="0"
              class="auto-width"
            >
              <cargo-ag-grid
                no="150004"
                config-module="150004"
                :grid-options="mergeOrder.gridOptions"
                :column-defs="mergeOrder.columnDefs"
                :row-data="mergeOrderFinalRowData"
                :auto-fit-content="false"
                style="width:100%;height:200px"
                @gridReady="params=>{mergeOrder.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button no="onMergeAddJob2" type="primary" :disabled="readonly" @click="pm.onMergeAddJob()">{{ $t('SeaExport.Add3') }}</el-button>
                  <el-button no="onMergeRemoveJob2" type="danger" :disabled="readonly" @click="pm.onMergeRemoveJob()">{{ $t('SeaExport.Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlType')">
              <el-select
                no="releaseType"
                :disabled="readonly"
                :value="form.releaseType||''"
                style="width: 100%"
                @input="val=>{form.releaseType=val}"
                @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CheckingStatus')" class="red ">
              <div style="display: flex">
                <el-input :value="lblCfrState" :disabled="true" style="flex: 1" />
                <el-link
                  v-if="showXhqOverseasAgentFeedbackLink"
                  no="xhqOverseasAgentFeedbackLink"
                  style="color: blue;margin-left: 5px"
                  @click="xhqShowOverseasAgentFeedbackDialog"
                >{{ $t('SeaExport.View') }}
                </el-link>
              </div>
            </el-form-item>

            <!-- 提单签发状态 -->
            <el-form-item :label="$t('SeaExport.BillLadingIssued')" class="red">
              <el-input v-model="billLadingIssued" :disabled="true" no="6" />
            </el-form-item>

            <el-form-item label-width="0">
              <el-button
                v-if="OpenXHQDocumentCenter"
                v-permission="['button_HBL_surrendered']"
                :disabled="isEdit"
                no="surrendered"
                type="primary"
                @click="pm.toSurrendered()"
              >{{ $t('SeaExport.Surrendered') }}</el-button>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red ">
              <el-input :value="lblReleaseState" :disabled="true" no="7" />
            </el-form-item>
            <el-form-item>
              <el-checkbox
                no="DataSent"
                :value="form.releaseReview===1"
                :disabled="true"
                style="margin-right: 6px;"
              >{{ $t('SeaExport.DataSent') }}</el-checkbox>
              <el-checkbox no="payable" :value="form.payable" :disabled="true" style="margin-right: 6px;">{{ $t('SeaExport.Completed') }}</el-checkbox>
              <el-checkbox no="withhold" :value="form.withhold" :disabled="true" style="margin-right: 0px;">{{ $t('SeaExport.CargoDetention') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.RequestReleaseState')" class="red">
              <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
              <cargo-button-container
                no="requestReleaseState"
                :disabled="btnBLConfirmDisabled || !cooperateEdit"
                style="float:right;margin-left:5px"
                @click="pm.btnRequestReleasingClickHandler()"
              >
                <el-button v-permission="['button_M/HBL_SingleReleaseHBL']" type="primary">{{
                  form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease')
                }}
                </el-button>
              </cargo-button-container>
            </el-form-item>
            <el-form-item
              v-if="guaranteeConfigEnable"
              :label="$t('SeaExport.LongTermGuaranteeState')"
              class="red"
            >
              <el-input :value="SystemConstants.LONG_TERM_GUARANTEE_STATE_MAP.get(longTermGuaranteeState)" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="guaranteeConfigEnable"
              :label="$t('SeaExport.SingleTicketGuaranteeState')"
              class="red"
            >
              <el-input :value="SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_MAP.get(singleTicketGuaranteeState)" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfcompletion')">
              <el-date-picker
                v-model="form.agreePayDate"
                :disabled="isDatePickerDisabled"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                no="8"
                @input="handleDateChange"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
              <el-date-picker
                v-model="form.withholdDate"
                :disabled="true"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                no="9"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ParamRemark')">
              <el-select v-model="form.printParam4" no="printParam4" :disabled="readonly" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')" filterable allow-create style="width: 100%;">
                <el-option
                  v-for="(item,index) in pm.printParam4Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.GenerationOfABillOfLading')">
              <el-select v-model="form.printParam5" no="printParam5" :disabled="readonly" :placeholder="readonly ? '': $t('CargoMsg.Cargo_PleaseSelect')" style="width: 100%;">
                <el-option
                  v-for="(item,index) in pm.printParam5Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContainerAmount')">
              <el-input
                v-model="form.seaeq"
                :disabled="readonly"
                no="seaeq"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ContainerAmount'),form.seaeq,val=>{form.seaeq=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CNTRNOSSEALNOS')">
              <el-input
                v-model="form.container"
                :disabled="readonly"
                no="container"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
              <el-input :value="form.withholdReason" type="textarea" :rows="5" :disabled="true" style="width: 100%;" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
              <el-input :value="txtCarrierScAc" :disabled="true" no="10" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
              <el-input :value="txtBookingAgentScAc" :disabled="true" no="11" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShipperContactTelNo')">
              <el-input v-model="form.shipperTel" no="shipperTel" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsigneeContactTelNo')">
              <el-input v-model="form.consigneeTel" no="consigneeTel" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyPartyTelNo')">
              <el-input v-model="form.notifyTel" no="notifyTel" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PortRequirement')">
              <el-input v-model="form.portRequirement" :disabled="readonly" no="portRequirement" type="textarea" :rows="5" />
              <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
                <i class="el-icon-paperclip" style="font-size: 16px;" />
                <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section">
        <span class="title">{{ $t('SeaExport.BillOfLadingPackingInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button no="AddPackingInfo" type="primary" @click="cargoDocUsageSelectedDialog.visible=true">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="RemovePackingInfo" type="primary" @click="removeContainerUsageClickHandler">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
          <cargo-ag-grid
            no="BillOfLadingPackingInfo"
            :grid-options="container.gridOptions"
            :column-defs="containerColumnDefs"
            :row-data="ediContainerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{container.gridApi=params.api}"
          />
        </div>
      </div>
      <div class="section">
        <span class="title">{{ $t('SeaExport.freightChargesInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button no="Add2" type="primary" @click="showEditDialog(true)">{{ $t('SeaExport.Add') }}</el-button>
            <el-button no="Edit2" type="primary" @click="showEditDialog(false)">{{ $t('SeaExport.Edit') }}</el-button>
            <el-button no="Delete2" type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            no="freightChargesInfo"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="finalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi=params.api}"
          />
          <div style="padding:5px 0;font-size:12px">
            <span style="color:#0A0AFF">{{ $t('SeaExport.freightChargesUSDTotal') }}</span>
            <i style="margin-left:15px;margin-right:5px">{{ form.freightChargeEnUpper }}</i>
            <i>({{ NumberUtils.formatNumber(form.freightChargeTotal, 2) }})</i>
          </div>
        </div>
      </div>
      <!-- 高级文本弹框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="advanceTextDialog.visible"
        :title="advanceTextDialog.title"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <cargo-rich-textarea
          ref="advanceTextDialogTextarea"
          v-model="advanceTextDialog.value"
          :text-chars="advanceTextDialog.formatObj.maxChar"
          :auto-uppercase="advanceTextDialog.isUppercase"
          :warning-count="advanceTextDialog.formatObj.warningCount"
          :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
          :disabled="readonly"
          style="height: 320px;"
          no="12"
        />
        <span slot="footer">
          <el-button v-show="isEdit" type="primary" no="13" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
          <el-button
            no="14"
            @click="advanceTextDialog.visible=false"
          >{{ $t('common.btn.close') }}</el-button>
        </span>
      </el-dialog>
      <!-- 收发通地址弹窗 -->
      <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="job" :params="form" @callback="codeSearchCallback" />
      <!-- 工作单检索弹窗 -->
      <job-no-transcribe-dialog
        :visible.sync="searchJobNoDialog.visible"
        :params="searchJobNoDialog.params"
        @selected="searchJobNoDialog.selectHandler"
      />
      <!-- 邀请对单弹窗 -->
      <email-input
        v-if="emailInput.visible"
        :visible.sync="emailInput.visible"
        :context="context"
        :job="job"
        source="tabHBL2"
        :is-copy-link="true"
        :job-eamil-data="jobEamilData"
        :send-email-data="emailInput"
        :send-call-back="onEmailExecute"
      />
      <!-- 抄录弹窗 -->
      <transcribe-dialog :visible.sync="transcribeDialog.visible" :job="job" @callback="transcribeCallback" />
      <!-- 反恐地址格式化弹窗 -->
      <address-format-dialog
        :visible.sync="addressFormatDialog.visible"
        :job="job"
        :params="addressFormatDialog.params"
      />
      <!-- 选择装箱信息弹窗 -->
      <add-cargo-doc-container-dialog
        :visible.sync="cargoDocUsageSelectedDialog.visible"
        :job="job"
        :doc-type="CargoDocConsts.HBL2"
        :uuid-not-empty="true"
        :cargo-docs="job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? splitOrderFinalRowData : null"
        @callback="cargoDocUsageSelectedDialog.callback"
      />
      <!-- 打印报表对话框 -->
      <cargo-template-selector-dialog
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.ctx"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        :context="context"
        :pre-print-callback="prePrintCallback"
        :printed-callback="printedCallback"
        :v2-check-callback="v2CheckCallback"
        :return-main-callback="returnMainCallback"
      />
      <!-- 编辑弹窗 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="editDialog.visible"
        :title="editDialog.title"
        width="465px"
        :close-on-click-modal="false"
      >
        <div class="app-main-inner-row" style="padding-bottom: 10px;">
          <el-form label-width="100px" label-position="left">
            <el-form-item :label="$t('SeaExport.ChargeItem')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_ChargeItem"
                filterable
                :default-value="editDialog.form.chargeItemId||''"
                style="width:100%;"
                no="15"
                @parentCallBack="p=>{editDialog.form.chargeItemId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargeClause')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :default-value="editDialog.form.paymentTermHBL"
                style="width:100%;"
                no="16"
                @parentCallBack="p=>{editDialog.form.paymentTermHBL=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Currency')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Currency"
                filterable
                :default-value="editDialog.form.currency"
                style="width:100%;"
                no="17"
                @parentCallBack="p=>{editDialog.form.currency=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContainerSize')">
              <cargo-advance-select
                :select-type="selectTypeNames.local_cache_EQSize"
                filterable
                :default-value="editDialog.form.eqSize"
                style="width:100%;"
                no="18"
                @parentCallBack="p=>{editDialog.form.eqSize=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContainerType')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_EQType"
                filterable
                :default-value="editDialog.form.eqType"
                style="width:100%;"
                no="19"
                @parentCallBack="p=>{editDialog.form.eqType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Quantity2')" :class="variableCss.quantity">
              <el-input-number
                v-model="editDialog.form.quantity"
                :precision="0"
                :controls="false"
                style="width:100%"
                no="20"
                @change="caculateAmount"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UnitRate')">
              <el-input-number
                v-model="editDialog.form.unitRate"
                :precision="2"
                :controls="false"
                style="width:100%"
                no="21"
                @change="caculateAmount"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Amount')">
              <el-input-number
                v-model="editDialog.form.amount"
                :precision="2"
                :controls="false"
                style="width:100%"
                no="22"
                @change="editDialog.form.unitRate=editDialog.form.amount"
              />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button type="primary" no="23" @click="save">{{ $t('common.btn.save') }}</el-button>
          <el-button no="24" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </el-dialog>
      <!-- 对单历史弹窗 -->
      <match-history-dialog :visible.sync="matchHistoryDialog.visible" :cargo-doc-uuid="form.uuid" />
      <!-- 查看编辑货物信息弹窗 -->
      <trade-detail-window
        :visible.sync="tradeDetailDialog.visible"
        :cargo-doc="form"
        :container-info="tradeDetailDialog.containerInfo"
        @callBackFun="reloadEDIContainer"
      />
    </div>
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :file-size="cloudFile.fileSize"
      :file-category="cloudFile.fileCategory"
      :file-category-label="cloudFile.fileCategoryLabel"
      :upload-source="cloudFile.uploadSource"
      :other-param="cloudFile.otherParam"
      @uploadDone="onUploadDone"
    />
    <el-dialog
      :visible.sync="checkTheBLLog.visible"
      :title="$t('SeaExport.CheckTheBLCenterApiLog')"
      width="1000px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      top="5vh"
      custom-class="details-view settlement-notice"
    >
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="checkTheBLLog.gridParams"
            :grid-options="checkTheBLLog.gridOptions"
            :column-defs="checkTheBLLog.columnDefs"
            :row-data="checkTheBLLog.rowData"
          />
        </div>
      </div>
    </el-dialog>
    <xhq-overseas-agent-feedback-dialog
      :visible.sync="xhqOverseasAgentFeedbackDialog.visible"
      :data="xhqOverseasAgentFeedbackDialog.data"
      :callback="xhqOverseasAgentFeedbackDialog.callback"
    />
    <!--保函上传文件-->
    <guarantee-file-dialog
      :visible.sync="guaranteeFileDialog.visible"
      :model="guaranteeFileDialog.model"
      :title="$t('Message.fileManagement')"
    />
  </div>
</template>

<script>
import { TabHBL2PM } from './tabHBL2PM'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import emailInput from '@/components/Cargo/Job/emailInput'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import addressFormatDialog from '@/views/cargo/v0/SeaExport/components/edi/addressFormatDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import cargoComboBox from '@/components/Cargo/Common/cargoComboBox'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import moment from 'moment'
import { formatNumberToThousands } from '@/utils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum, ensureExecuteSuccess, mergeArray, multiply } from '@/utils/commonUtil'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { FreightCharges } from '@/class/model/booking/FreightCharges'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import agGridColumnEdit from '@/components/Cargo/grid/agGridColumnEdit' // agGrid列编辑组件
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import matchHistoryDialog from '@/components/Cargo/Job/matchHistoryDialog'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { sendHblCargoDocEmail } from '@/api/sendEmailService'
import OperationRender from '@/components/OperationRender/index'
import { cache } from '@/utils/cacheManager'
import TradeDetailWindow from '@/views/cargo/v0/Clearing/components/booking/TradeDetailWindow'
import { queryPoPackageCartonQuantity } from '@/api/seaExport/container'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { manualTriggerAndUpate } from '@/api/seaExport/seaExportJob'
import { getLoading } from '@/utils/utilBaseElement'
import AddCargoDocContainerDialog from '@/views/cargo/v0/SeaExport/components/booking/AddCargoDocContainerDialog'
import { Job } from '@/class/model/booking/Job'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import URL from '@/api/urlTranslator'
import { xhqSendCustomerFiles, xhqQueryOverseasAgentFeedback } from '@/api/seaExport/seaCargoDoc'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as AutomaticReleaseConstants from '@/class/cargo/model/parameters/AutomaticReleaseConstants'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import xhqOverseasAgentFeedbackDialog from '@/components/Cargo/Job/xhqOverseasAgentFeedbackDialog'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { INTELLIGENT_DOCUMENT_SOURCE_7 } from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import {
  LONG_TERM_GUARANTEE_STATE_INEFFECT,
  LONG_TERM_GUARANTEE_STATE_MAP, LONG_TERM_GUARANTEE_STATE_NONE,
  SINGLE_TICKET_GUARANTEE_STATE_MAP, SINGLE_TICKET_GUARANTEE_STATE_NOT_UPLOADED, SINGLE_TICKET_GUARANTEE_STATE_UPLOADED
} from '@/class/cargo/model/parameters/SystemConstants'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as ExternalFileType from '@/class/cargo/model/parameters/ExternalFileType'
import GuaranteeFileDialog from '@/components/Cargo/FileUpload/guaranteeFileDialog.vue'
import CargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'

export default {
  name: 'TabHbl2',
  components: {
    GuaranteeFileDialog,
    TradeDetailWindow, cargoCloudFileUpload,
    CargoRichTextarea, cargoPackingSelect, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, billAddressDialog, jobNoTranscribeDialog, emailInput,
    transcribeDialog, addressFormatDialog, cargoTemplateSelectorDialog, cargoComboBox, AddCargoDocContainerDialog, matchHistoryDialog,
    xhqOverseasAgentFeedbackDialog, CargoButtonContainer
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      billLadingIssued: '',
      jobEamilData: {},
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabHBL2PM(this),
      addrPM: new BillAddressCommonPM(this),
      moment,
      BillType,
      CargoDocConsts,
      CargoDocCfmState,
      NumberUtils,
      CargoDocUtil,
      selectTypeNames: TYPE_NAMES,
      mergeHblData: false,
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      mblMergeUpdateMainNumber: false,
      syncSignDateBl: false,
      poItemsTabViewModel: false,
      maxChars: 255,
      warningCount: 45,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: 0,
      markWarningCount: 0,
      btnPrintDisabled: true,
      hblNoDisabled: false,
      isUppercase: true,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      otherFieldsData: [],
      job: {},
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      chkConsolidationClosed: false,
      otherSelectField: '',
      otherCode: '',
      lblCfrState: '',
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      command1: this.$t('SeaExport.CodeSearching'),
      command2: this.$t('SeaExport.InviteToChecktheBL'),
      command3: this.$t('SeaExport.CopyMblConsignee'),
      variableCss: {
        quantity: '',
        shipperLine: '', // 发货人1
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        consigneeLine: '', // 收货人1
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        notifyLine: '', // 通知人1
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        agentPartyLine1: '', // 代理信息1
        agentPartyLine2: '', // 代理信息2
        agentPartyLine3: '', // 代理信息3
        agentPartyLine4: '', // 代理信息4
        agentPartyLine5: '', // 代理信息5
        agentPartyLine6: '', // 代理信息6
        BLNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        mark: '', // 唛头
        remarks: ''// 备注
      },
      // 拆单
      splitOrder: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          onRowClicked: event => {
            this.curHbl = event.data
            this.pm.onSplitSelectionChange(event.data)
            if (!this.curHbl.uuid && this.form.agreePayDate) {
              this.isDateRequired = !this.isDateRequired
            }
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.HblNo2'),
            field: 'hblNbr2',
            width: 130
          },
          {
            headerName: 'HBL Ref No.',
            field: 'hblRefNo',
            width: 130,
            hide: true
          }, {
            headerName: this.$t('SeaExport.NumberOfPackagesOnBl'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            hide: true,
            valueFormatter: (params) => {
              return (!params.value || isNaN(params.value) || Number(params.value) === 0) ? '' : params.value
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_InsideQuantity'),
            colId: 'insideQuantity',
            field: 'insideQuantity',
            width: 100,
            hide: true,
            valueFormatter: (params) => {
              return (!params.value || isNaN(params.value) || Number(params.value) === 0) ? '' : params.value
            }
          }, {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            hide: true
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            hide: true
          }, {
            headerName: this.$t('SeaExport.ChargedWeight'),
            colId: 'chargeWeight',
            field: 'chargeWeight',
            width: 100,
            hide: true
          }
        ],
        rowData: [],
        gridApi: null
      },
      // 并单
      mergeOrder: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 109
          },
          {
            headerName: this.$t('SeaExport.Mbl2'),
            colId: 'mbl',
            field: 'mbl',
            width: 109,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantityActual',
            field: 'quantityActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weightActual',
            field: 'weightActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubageActual',
            field: 'cubageActual',
            width: 85
          }
        ],
        rowData: [],
        gridApi: null
      },
      container: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            agGridColumnEdit
          }
        },
        rowData: [],
        gridApi: null
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ChargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 145,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        }, {
          headerName: this.$t('SeaExport.ChargeClause'),
          colId: 'paymentTermHBL',
          field: 'paymentTermHBL',
          width: 145
        }, {
          headerName: this.$t('SeaExport.Currency'),
          colId: 'currency',
          field: 'currency',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          width: 145
        }, {
          headerName: this.$t('SeaExport.Quantity2'),
          colId: 'quantity',
          field: 'quantity',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.UnitRate'),
          colId: 'unitRate',
          field: 'unitRate',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Amount'),
          colId: 'amount',
          field: 'amount',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0, autoUppercase: false, autoHalfWord: false
        }
      },
      billAddressDialog: {
        visible: false
      },
      searchJobNoDialog: {
        visible: false,
        params: {},
        selectHandler: () => {
        }
      },
      emailInput: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        fileIdList: '',
        overseasLink: ''
      },
      transcribeDialog: {
        visible: false
      },
      // 反恐舱单-反恐地址格式化-弹窗
      addressFormatDialog: {
        visible: false,
        params: { cargoDocs: [] }
      },
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => {
          this.pm.usageSelectCallBackFunc(rows)
        }
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaCargoDoc(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      returnMainCallback: null, // V1模板返回主页面回调事件
      lob: 'SE',
      editDialog: {
        visible: false,
        title: '',
        form: new FreightCharges().fillDefaultValue().getData()
      },
      addJoinMergeJobList: [], // 当前添加的并单（未保存）
      curHbl: null,
      matchHistoryDialog: {
        visible: false
      },
      tradeDetailDialog: { // 查看商品
        visible: false,
        containerInfo: {}
      },
      URL,
      OpenXHQDocumentCenter: false,
      ToExoSystemJYD: false,
      PICtoXHQDocumentCenter: 0,
      IfXHQReleaseRequireHBLReleaseReview: 0,
      cloudFile: {
        visible: false,
        job: new Job(),
        lob: 'SE',
        fileSize: 20480000,
        fileCategory: '',
        fileCategoryLabel: '',
        rowData: [],
        otherParam: {},
        uploadSource: ''
      },
      checkTheBLLog: {
        visible: false,
        jobUuid: '',
        sendType: '',
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.InterfaceName'), field: 'logSource', flex: 1,
            cellRenderer: (params) => {
              return ColumnUtils.xhqInterfaceLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.DataFlowDirection'),
            field: 'dataFlowDirection',
            flex: 1,
            cellRenderer: (params) => {
              return ColumnUtils.apiDataFlowDirectionLabelFunc(params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_SendDate'), field: 'dateCreated', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_PushMessage'), field: 'requestMsg', flex: 1 },
          {
            headerName: this.$t('SeaExport.createdBy'), field: 'createdBy', flex: 1,
            cellRenderer: (params) => {
              if (params.data.dataFlowDirection === SystemConstants.XHQ_TO_CW.code) {
                return '信号旗'
              }
              if (params.value === 999) { // 如果是保存自动触发发送提单更新，后端记录创建人为999，在前端转为SYSTEM
                return 'SYSTEM'
              }
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            },
            filterParams: {},
            filterValueGetter: (params) => {
              if (params.data.dataFlowDirection === SystemConstants.XHQ_TO_CW.code) {
                return '信号旗'
              }
              if (params.data.createdBy === 999) { // 如果是保存自动触发发送提单更新，后端记录创建人为999，前端转为SYSTEM
                return 'SYSTEM'
              }
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.createdBy, 'chineseName')
            }
          },
          { headerName: this.$t('CargoMsg.RespMsg'), field: 'responseMsg', flex: 1 }
        ],
        rowData: []
      },
      xhqOverseasAgentFeedbackDialog: {
        visible: false,
        data: {},
        callback: null
      },
      guaranteeFileDialog: {
        visible: false,
        model: {}
      },
      showXhqOverseasAgentFeedbackLink: false,
      isDateRequired: false, // 控制完成时间展示
      isItCleared: false,
      isXy: false,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      longTermGuaranteeState: 0,
      singleTicketGuaranteeState: 0,
      guaranteeConfigEnable: false
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    btnBLConfirmDisabled() {
      return this.isEdit || !this.form.uuid
    },
    config() {
      return this.context.config
    },
    user() {
      return this.context.user
    },
    // 开航日期
    sailingDate() {
      const val = this.syncSignDateBl ? this.job.atd : this.job.etd
      if (val === null || val === '') {
        return ''
      }
      return moment(val).format('YYYY-MM-DD')
    },
    splitOrderFinalRowData() {
      return this.splitOrder.rowData.filter(p => !p.deleted && p.docType === CargoDocConsts.HBL2).sort((a, b) => {
        const suffixA = a.hblNbr2.replace(`${this.job.jobNo}-`, '')
        const suffixB = b.hblNbr2.replace(`${this.job.jobNo}-`, '')
        return suffixA - suffixB
      })
    },
    mergeOrderFinalRowData() {
      return this.mergeOrder.rowData.filter(p => !p.deleted)
    },
    ediContainerFinalRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    containerColumnDefs() {
      return [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.SealNo'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          cellStyle: (params) => {
            return ContainerUtil.containerPushDataStyleFunction2(params, 'quantity')
          },
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        }, {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          cellStyle: (params) => {
            return ContainerUtil.containerPushDataStyleFunction2(params, 'weight')
          },
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          cellStyle: (params) => {
            return ContainerUtil.containerPushDataStyleFunction2(params, 'cubage')
          },
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'subItemNo',
          colId: 'subItemNo',
          width: 150,
          hide: !this.poItemsTabViewModel,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('SeaExport.View') + '/' + this.$t('SeaExport.Edit'),
                type: 'primary',
                cssStyle: 'text-decoration: underline; color: #1605FB',
                onClick: (params) => {
                  this.checkAndEditClickHandler(params)
                },
                visible: (params) => this.poItemsTabViewModel
              }
            ]
          }
        },
        {
          headerName: 'part of',
          colId: 'partOf',
          field: 'partOf',
          suppressColumnsToolPanel: this.job.typeHBL !== BillType.SPLIT_BILL_TYPE.code,
          hide: this.job.typeHBL !== BillType.SPLIT_BILL_TYPE.code,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox',
            valueChanged: p => {
              this.onPartOfChange(p)
            }
          }
        }
      ]
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    isDatePickerDisabled() {
      // 编辑状态
      if (this.isEdit) {
        // 符合日期为空
        if (!this.form.agreePayDate || this.isDateRequired) {
          if (this.form.agreePayDate) {
            this.isDateRequired = !this.isDateRequired
          }
          return false
        }
      }
      return true
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.job.uuid)
    }
  },
  created() {
    this.context.loading = true
    // await this.context.prepareData()
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.poItemsTabViewModel = Number(this.config.get('PoItemsTabViewModel')) === 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isXy = String(this.config.get('ToExoSystem')) === 'XYCW'
    this.pm.init()
    this.visible = true
    this.context.loading = false
  },
  methods: {
    updateCfm() {
      this.job.hblCfmState = 11
      this.form.cfmState = 11
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.hblCfmState)
    },
    splitOrderGridReady(params) {
      this.splitOrder.gridApi = params.api
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        this.pm.showScac()
        this.pm.loadSplitMBLs()
        new SeaCargoDoc(this.form).getEdiContainer().then(data => {
          this.container.rowData = data
        })
        if (this.container.gridApi) {
          this.container.gridApi.refreshCells({ force: true })
        }
        return
      }
      this.syncSignDateBl = Number(this.config.get('syncSignDateBl')) === 1
      this.addJoinMergeJobList = []
      this.job = row
      await this.pm.display()
      await this.pm.fillView()
      this.$nextTick(async() => {
        console.log()
        if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) { // 拆单
          await ensureExecuteSuccess(() => this.splitOrder.gridApi)
          let selectedNode = null
          const { rowsToDisplay } = this.splitOrder.gridApi.getModel()
          if (this.curHbl) {
            selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curHbl.hblNbr2) || rowsToDisplay[0]
          } else {
            selectedNode = rowsToDisplay[0]
          }
          const selectedData = selectedNode ? selectedNode.data : this.splitOrderFinalRowData[0]
          if (selectedData) {
            if (selectedNode) {
              selectedNode.setSelected(true)
            }
            await this.pm.onSplitSelectionChange(selectedData)
          }
        }
      })
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.form.cfmState)
      this.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
      this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
    },
    getSubmitData() {
      // CARGO-20365先触发富文本组件失焦事件去除尾部换行符
      this.$refs.cargoTextarea1.hanldeFormat()
      this.$refs.cargoTextarea2.hanldeFormat()
      const docs = this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? this.splitOrderFinalRowData : [this.form]
      for (const item of docs) {
        this.validateRequire(item)
      }
      if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
        CargoDocUtil.checkDocQWCSame(this.splitOrderFinalRowData, this.job.containerUsages)
      }
      this.pm.validateForm()
      this.pm.fillModel()
      let seaCargoDoc = null
      if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
        seaCargoDoc = this.splitOrder.rowData
      } else {
        seaCargoDoc = [this.form]
      }
      return {
        seaCargoDoc,
        isItCleared: this.isItCleared,
        afrAddressList: this.chkConsolidationClosed ? this.form.afrAddress : null,
        hblJoinMergeJobList: this.addJoinMergeJobList,
        job: { ...this.job }
      }
    },
    validateRequire(cargoDoc) {
      // UI自定义中用到
    },
    executeTask() {
      this.pm.executeTask()
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          this.job.key = this.job.uuid
          Object.assign(this.searchJobNoDialog.params, {
            selectType: 'single',
            docType: 'HBL',
            job: this.job
          })
          this.searchJobNoDialog.selectHandler = p => {
            this.pm.selectionItemHandler(p)
          }
          this.searchJobNoDialog.visible = true
          break
        case this.$t('SeaExport.CopyCargoDescriptionAndMarks'):
          this.transcribeDialog.visible = true
          break
        case this.$t('SeaExport.InviteToChecktheBL'):
          JobUtils.checkBillTip(this.form, this.doInviteConfirmData)
          break
        case this.$t('SeaExport.ConfirmChecking'):
          this.pm.confirmBtn_clickHandler()
          break
        case this.$t('SeaExport.CopyMblConsignee'):
          this.pm.onCopy_agentParty()
          break
        case this.$t('SeaExport.CopyNominatedAgentInfo'):
          this.pm.onCopy_designationAgent()
          break
        case this.$t('SeaExport.CheckingHistory'):
          this.matchHistoryDialog.visible = true
          break
        case this.$t('SeaExport.UploadGuarantee'):
          this.uploadGuaranteeHandler()
          break
        case this.$t('SeaExport.IdentificationList'):
          this.$router.push({
            name: 'OcrRecognition',
            query: {
              uuid: this.job.uuid,
              docUuid: this.form.uuid,
              source: INTELLIGENT_DOCUMENT_SOURCE_7.code
            }
          })
          break
      }
    },
    uploadGuaranteeHandler() {
      if (!this.form || !this.form.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
        return
      }
      const params = {}
      params.jobUuid = this.form.jobUuid
      params.jobNo = this.job.jobNo
      params.docUuid = this.form.uuid
      params.hbl = this.form.hblNbr2
      params.uuid = this.form.jobUuid
      params.documentType = ExternalFileType.HBL_SINGLE_TICKET_GUARANTEE.code
      params.documentCategory = this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? DocumentConstants.SINGLE_TICKET_GUARANTEE_SPLIT.code : DocumentConstants.SINGLE_TICKET_GUARANTEE_MERGE.code
      this.guaranteeFileDialog.model = params
      this.guaranteeFileDialog.visible = true
    },
    doInviteConfirmData() {
      SeaCargoDoc.getCfmAddress(this.form.uuid, this.form.version, this.user.tenantName, this.job.jobNo, this.$store.getters.currentOfficeId, this.user.email).then(data => {
        if (data.cargoDoc) {
          Object.assign(this.form, data.cargoDoc)
          this.pm.showDocState()
        }
        this.emailInput.emailTitle = ''
        if (this.form.hblNbr2) {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}-${this.form.hblNbr2}(${this.context.office.chineseName})`
        } else {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}(${this.context.office.chineseName})`
        }
        this.emailInput.anonSessionId = data.anonSessionId
        this.emailInput.emailContent = data.url
        this.emailInput.fileIdList = ''
        this.emailInput.visible = true
        this.jobEamilData = {
          anonSessionId: this.emailInput.anonSessionId,
          jobuuid: this.job.uuid,
          cargoDocUuid: this.form.uuid,
          format: PrintTemplateManager.FORMAT_PDF,
          createdBy: this.$store.getters.userId,
          templateType: this.form.docType,
          className: 'CargoDoc',
          classNameType: SystemConstants.BOOKING,
          officeId: this.$store.getters.currentOfficeId,
          tenantName: this.user.tenantName
        }
      })
    },
    codeSearchCallback(data) {
      if (data.shipperCode) {
        this.form.shipperCode = data.shipperCode
      }
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeCode) {
        this.form.consigneeCode = data.consigneeCode
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyCode) {
        this.form.notifyCode = data.notifyCode
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    mergeAgentPartyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['agentPartyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['agentPartyLine7'] || '')
      return result.trimEnd()
    },
    splitAgentPartyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['agentPartyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['agentPartyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['agentPartyLine' + i] = ''
      }
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: 255, warningCount: 45, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: 255, warningCount: 45, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: 255, warningCount: 45, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showAgentPartyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.AgentInfo'), this.mergeAgentPartyLine(), this.splitAgentPartyLine, true, {
        maxChar: 255, warningCount: 45, autoUppercase: true, autoHalfWord: true
      })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    // 解锁
    unlock() {
      this.pm.onSubmitStatEvent()
      this.form.bliStatus = 0
      this.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
    },
    /**
     * 正本打印
     */
    async originalPrint() {
      // CARGO-17813 485 智中行 开启“正本/电放打印是否验证HBL放单状态”拆单依然可放单
      // HBL 放单状态为”待审核“，点击正本/电放按钮，弹出提示框”不是可放单，无法打印“
      if (Number(this.config.get('CheckHBLReleaseStateBeforePrint')) === 1) {
        // releaseState=1(待审核)/2(已放单) 时允许打印，其它状态拦截
        if (this.form.releaseState !== ReleaseState.SINGLERELEASE.code && this.form.releaseState !== ReleaseState.ONSINGLERELEASE.code) {
          this.$message.info(this.$t('Message.CheckHBLReleaseStateBeforePrint'))
          return
        }
      }

      // CARGO-40140 电放打印校验是否存在长期保函或者单票保函
      if (this.form.releaseType !== BillReleaseType.ORIGINAL.code && this.guaranteeConfigEnable &&
        this.singleTicketGuaranteeState === SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_NOT_UPLOADED.code &&
          this.longTermGuaranteeState !== SystemConstants.LONG_TERM_GUARANTEE_STATE_INEFFECT.code) {
        this.$message.warning(this.$t('Message.PleaseUploadReleaseGuarantee'))
        return
      }

      if (this.pm.originalPrintCheckSerialNo && this.form.releaseType === 1 && !this.form.serialNo) {
        this.$message.info(this.$t('Message.PleaseEnterTheBillOfLadingSerialNumber'))
        return
      }
      console.log('this.form.uuid', this.form.uuid, this.form.warehouseNo)
      const data = {
        uuid: this.form.uuid,
        state: 1,
        setting: 0,
        btnType: AutomaticReleaseConstants.HBL_ORIGINAL_PRINTING.code
      }
      this.loading = getLoading()
      const res = await manualTriggerAndUpate(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        if (res.data.result === 2) {
          const messages = []
          const createElement = this.$createElement
          messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.businessNumber') + res.data.jobNo))
          if (res.data.mbl) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.mblNo') + res.data.mbl))
          }
          if (res.data.hbl) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.hblNo') + res.data.hbl))
          }
          if (res.data.tip.accountCompanyName) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.accountCompanyName))
          }
          if (res.data.tip.accountOverCreditLimitDate) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
          }
          if (res.data.tip.accountOverCreditLimitAmount) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.accountOverCreditLimitAmount)))
          }
          if (res.data.tip.agentCompanyName) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.agentCompanyName))
          }
          if (res.data.tip.agentOverCreditLimitDate) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
          }
          if (res.data.tip.agentOverCreditLimitAmount) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.agentOverCreditLimitAmount)))
          }
          if (res.data.tip.customerCompanyName) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.customerCompanyName))
          }
          if (res.data.tip.customerOverCreditLimitDate) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
          }
          if (res.data.tip.customerOverCreditLimitAmount) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.customerOverCreditLimitAmount)))
          }
          messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.triggerRemind')))
          await this.$confirm('', {
            title: this.$t('ReleaseNotes.lineCreditDialog.title'),
            message: createElement('div', null, messages),
            confirmButtonText: this.$t('ReleaseNotes.lineCreditDialog.cancel'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
          })
          this.form.releaseState = 4
          this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
          return
        }
        if (res.data.result === 1) {
          this.$message({
            message: this.$t('ReleaseNotes.lineCreditDialog.through'),
            type: 'success',
            customClass: 'messageIndex'
          })
          this.job.hblCfmState = 10
          this.form.cfmState = 10
          this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.hblCfmState)
          this.form.releaseState = 2
          this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
        }
      }
      const params = {}
      params.cargoDocUuid = this.form.uuid
      params.fileAliasName = this.form.hblNbr2
      params.DOC_UUID = this.form.uuid
      params.hblNo = this.form.hblNbr2
      params.hblRefNo = this.form.hblRefNo
      // CARGO-6750，SOP回调cargo失败。UUID中有 /导致url匹配不上了
      params.printCallBackUrl = 'services/printExec/entity/update2/CargoDoc?key=' + encodeURIComponent(this.form.uuid) + '&fieldCount=1&field1=state&value1=2'
      if (this.isXy) {
        params.printCallBackUrl = 'services/printExec/entity/update2/CargoDoc?key=' + encodeURIComponent(this.form.uuid) + '&fieldCount=1&field1=state&value1=1'
      }
      this.templateSelectorDialog.ctx = new SeaCargoDoc(this.form)
      this.templateSelectorDialog.category = this.form.releaseType === 1 ? 'HBL2ZB' : 'HBL2DF'
      this.templateSelectorDialog.data = params
      // 组装打印回调函数
      this.prePrintCallback = null
      // CARGO-16750 HBL正本或电放打印 V1模板也增加“是否打印成功”选项
      this.printedCallback = null
      this.returnMainCallback = event => {
        this.pm.print_callback(event)
      }
      this.v2CheckCallback = (isSure, template, entity, arms) => {
        this.pm.v2CheckCallbackFun2(isSure, template, entity, arms)
      }
      this.templateSelectorDialog.visible = true
    },
    showAddressFormatDialog() {
      this.addressFormatDialog.params = { cargoDocs: [this.form] }
      this.addressFormatDialog.visible = true
    },
    packageInfoChanged(params) {
      const newValue = Number(params.newValue)
      if (newValue < 0) {
        params.node.setDataValue(params.column.colId, 0)
        return
      }

      // 值未变更的情况下不用重新计算
      if (Number(params.newValue) === Number(params.oldValue)) return
      const { field } = params.colDef
      // 拆单专用
      if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code && !this.isXy) {
        let sum = 0
        for (const item of this.container.rowData) {
          sum += Number(item[field])
        }
        this.form[field] = sum
        CargoDocUtil.calculateSEChargeWeight(this.form)
      }
    },
    /**
     * Part Of 发生变更
     */
    onPartOfChange(params) {
      const partOf = params.data.partOf
      const containerUsageUuid = params.data.containerUsageUuid
      for (const row of this.splitOrderFinalRowData) {
        if (row.ediContainer) {
          for (const container of row.ediContainer) {
            if (container.containerUsageUuid === containerUsageUuid) {
              container.partOf = partOf
            }
          }
        }
      }
      this.container.gridApi.refreshCells({ force: true })
    },
    /**
     * 移除装箱信息
     */
    removeContainerUsageClickHandler() {
      const rows = this.container.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PleasePackingInformationToRemoved'))
        return
      }
      const rowData = []
      const delEdiUuids = []
      for (const item of this.container.rowData) {
        let isExist = false
        for (const row of rows) {
          // if (row.eqSize === item.eqSize && row.eqType === item.eqType &&
          //   row.containerNo === item.containerNo && row.sealNo === item.sealNo) {
          if (row === item) {
            isExist = true
            delEdiUuids.push(row.uuid)
            break
          }
        }
        if (isExist) {
          item.deleted = true
        }
        if (!item.uuid && item.deleted) {
          continue
        }
        rowData.push(item)
      }
      this.container.rowData = rowData
      if (this.job.containers) {
        for (const container of this.job.containers) {
          if (container.containerUsage) {
            for (const usage of container.containerUsage) {
              if (usage.ediContainers) {
                for (const ediContainer of usage.ediContainers) {
                  if (delEdiUuids.indexOf(ediContainer.uuid) > -1) {
                    ediContainer.deleted = true
                  }
                }
              }
            }
          }
        }
      }
      this.pm.refreshSeqContainer(this.container.rowData)
      // 拆单专用
      if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code && !this.isXy) {
        this.pm.refreshEdiGrid()
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        const newRow = new FreightCharges().fillDefaultValue().getData()
        newRow.cargoDocUuid = this.form.uuid
        this.editDialog.form = newRow
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.finalRowData[cell.rowIndex] : undefined
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (!row.seq) {
          row.seq = this.autoIncrementNum.getNextNum()
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    caculateAmount() {
      const form = this.editDialog.form
      form.amount = (form.quantity || 0) * (form.unitRate || 0)
    },
    save() {
      const form = this.editDialog.form
      if (!form.seq) {
        this.rowData.push(form)
        setTimeout(() => {
          this.gridApi.setFocusedCell(this.finalRowData.length - 1)
        }, 100)
      } else {
        const row = this.rowData.find(p => p.seq === form.seq)
        if (row) {
          Object.assign(row, form)
          this.gridApi.refreshCells({ force: true })
        }
      }
      this.pm.refershFreightChargeTotal()
      this.editDialog.visible = false
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.finalRowData[cell.rowIndex] : undefined
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (row.uuid) {
        row.deleted = true
        /* 强制刷新finalRowData */
        const tempRowData = this.rowData
        this.rowData = []
        this.$nextTick(() => {
          this.rowData = tempRowData
        })
      } else {
        const index = this.rowData.findIndex(p => p === row)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      }
      this.pm.refershFreightChargeTotal()
    },
    endTabHandler() { // 切换页签调用的方法
      this.pm.validateForm()
      this.pm.fillModel()
    },
    // 组装打印参数
    getPrintData() {
      if (!this.form || !this.form.uuid) {
        this.$message.warning(this.$t('Message.NoSelectedCargoDocInformation'))
        return
      }
      const params = {}
      if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
        params.jobuuid = this.job.uuid
        params.cargoDocUuid = this.form.uuid
        params.fileAliasName = this.form.hblNbr2
        params.DOC_UUID = this.form.uuid
        params.category = 'HBL2'
        params.hblRefNo = this.form.hblRefNo
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(view.job, "HBL2", params1, view);
      } else if (this.job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
        params.jobuuid = this.job.uuid
        params.cargoDocUuid = this.form.uuid
        params.fileAliasName = this.form.hblNbr2
        params.DOC_UUID = this.form.uuid
        params.category = 'HBL2'
        params.hblRefNo = this.form.hblRefNo
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(view.job, "HBL2", params1, view);
      }
      params.v2CheckCallback = null
      this.$logger.log('params', params)
      return params
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    hblNbr2Change() {
      const { gridApi } = this.splitOrder
      gridApi.refreshCells()
      this.$nextTick(() => {
        const { rowsToDisplay } = gridApi.getModel()
        const selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curHbl.hblNbr2)
        if (!selectedNode) {
          return
        }
        selectedNode.setSelected(true)
      })
    },
    getClass(key, index) {
      const variableCss = this.variableCss[key + index]
      const shouldWarn = this.warningCount !== -1 && this.form[key + index].length > this.warningCount
      if (variableCss || shouldWarn) {
        return 'red'
      }
      return ''
    },
    /**
     * @private
     * 邀请对单邮件callBack
     * 返回方法
     */
    onEmailExecute(mailSubject, mailTo, mailCc, content, mailType, mailContent, pushLink, customerTypeName) {
      const item = {}
      item.mailTo = mailTo
      item.pushLink = pushLink
      item.mailSubject = mailSubject
      item.mailCc = mailCc
      item.mailBcc = ''
      item.mailFrom = ''
      // item.mailFrom = this.getMailFrom() // 后端已经写死了，此方法无用
      item.cfmUrl = content
      item.anonSessionId = this.emailInput.anonSessionId
      item.jobuuid = this.job.uuid
      item.cargoDocUuid = this.form.uuid
      item.format = PrintTemplateManager.FORMAT_PDF
      item.createdBy = this.$store.getters.userId
      item.templateType = this.form.docType
      item.className = 'CargoDoc'
      item.classNameType = SystemConstants.BOOKING
      item.officeId = this.$store.getters.currentOfficeId
      item.tenantName = this.user.tenantName
      item.mailType = mailType || ''
      item.mailContent = mailContent || ''
      item.customerTypeName = customerTypeName || ''
      item.openXHQDocumentCenter = this.OpenXHQDocumentCenter
      sendHblCargoDocEmail(item).then(res => {
        if (res.ok) {
          this.emailInput.visible = false
          this.$message.success(this.$t('CargoMsg.Cargo_EMSSCM'))
          this.pm.statusHistoryWaitConfirmSuccessHandler()
        } else {
          this.$message.warning(this.$t('SeaExport.MailSendingFailed'))
        }
      })
    },
    // 编辑查看订单信息
    checkAndEditClickHandler(containerInfo) {
      if (this.action !== 'look' || !containerInfo.uuid) {
        this.$message.warning(this.$t('SeaExport.goodsOperateTips'))
        return
      }
      this.tradeDetailDialog.containerInfo = containerInfo
      this.tradeDetailDialog.visible = true
    },
    reloadEDIContainer() {
      // 查看状态重新从数据库加载
      if (this.action === 'look') {
        this.form.ediContainer = ''
      }
      new SeaCargoDoc(this.form).getEdiContainer().then(data => {
        this.container.rowData = data
      })
      this.container.gridApi.refreshCells({ force: true })
      this.containerPackageChanged()
    },
    containerPackageChanged() {
      if (this.poItemsTabViewModel && this.form.uuid) {
        // EdiContainerPackage.queryPoPackageCartonQuantity(cargoDoc.key, cartonQuantityResultHandler, faultHandler);
        queryPoPackageCartonQuantity({ anyStr: this.form.uuid }).then(res => {
          const result = res.data
          if (result) {
            this.form.insideQuantity = result.cartonQuantity
            this.form.cubage = result.totalCubage
            this.form.weight = result.totalWeight
            this.form.quantity = result.totalQuantity
          }
        })
      }
    },
    async XHQDocumentCenterSelectHandler(index) {
      switch (index) {
        case 'InviteToChecktheBL':
          await this.pm.toGetXHQCfmAddress(this.form.uuid).then(data => {
            if (data.cargoDoc) {
              Object.assign(this.form, data.cargoDoc)
              this.pm.docCfmStateChanged()
            }
            this.emailInput.emailTitle = ''
            if (this.form.hblNbr2) {
              this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}-${this.form.hblNbr2}(${this.context.office.chineseName})`
            } else {
              this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}(${this.context.office.chineseName})`
            }
            this.emailInput.anonSessionId = data.anonSessionId
            this.emailInput.emailContent = data.url
            this.emailInput.overseasLink = data.overseasLink
            this.emailInput.fileIdList = ''
            this.emailInput.visible = true
            this.jobEamilData = {
              anonSessionId: this.emailInput.anonSessionId,
              jobuuid: this.job.uuid,
              cargoDocUuid: this.form.uuid,
              format: PrintTemplateManager.FORMAT_PDF,
              createdBy: this.$store.getters.userId,
              templateType: this.form.docType,
              className: 'CargoDoc',
              classNameType: SystemConstants.BOOKING,
              officeId: this.$store.getters.currentOfficeId,
              tenantName: this.user.tenantName
            }
          })
          break
        case 'BillOfLadingConfirmationDocument':
          this.pm.toUploadFile('CONFIRMATION OF BILL OF LADING', '提单确认件', 'BILL')
          break
        case 'CustomerSelfIssuedFiles':
          this.pm.toUploadFile('CUSTOMERSELFRELEASE', '客户自出单文件', 'OWN_BILL')
          break
        case 'CheckTheBLLog':
          await this.pm.toCheckTheBLLog()
          break
        case 'ConfirmChecking':
          this.pm.xhqConfirmBL()
          break
        case 'OriginBillOfLading':
          this.pm.toUploadCommonFile('ORIGINAL BILL OF LADING', '正本提单')
          break
        case 'IdentificationList':
          this.$router.push({
            name: 'OcrRecognition',
            query: {
              uuid: this.job.uuid,
              docUuid: this.form.uuid,
              source: INTELLIGENT_DOCUMENT_SOURCE_7.code
            }
          })
          break
        case 'ShippingOrder':
          this.pm.toUploadFile('SHIPPING_ORDER', '托书文件', 'SHIPPING_ORDER')
          break
        case 'UploadGuarantee':
          this.uploadGuaranteeHandler()
          break
        default:
          break
      }
    },
    /**
     * 发送客户文件到信号旗
     */
    onUploadDone(files) {
      if (this.cloudFile.fileCategory === 'ORIGINAL BILL OF LADING') {
        return
      }
      const phone = this.getContactPhone()
      if (!phone) {
        return
      }
      if (!files || !(files.length > 0) || !files[0].fileId) {
        return
      }
      const data = {
        anyStr: this.job.jobNo,
        anyStr1: files[0] ? files[0].fileId : '',
        anyStr2: this.form.hblRefNo,
        anyStr3: phone,
        anyStr4: this.job.uuid,
        anyStr5: files[0] && files[0].params ? files[0].params.xhqSendType : '',
        anyStr6: this.form.uuid,
        anyInteger: this.job.typeHBL,
        anyInteger1: this.job.opOffice
      }
      xhqSendCustomerFiles(data).then(res => {
        if (res.ok) {
          this.$message.success(this.$t('CargoMsg.Cargo_SendSuccess'))
          // 发送成功跟新状态为待制单
          this.form.cfmState = res.data
          this.job.hblCfmState = res.data
          this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.hblCfmState)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    getContactPhone() {
      let phone = ''
      let userId = 0
      // 推送信号旗单证中心的联系人岗位 0=操作，1=客服，2=单证
      if (this.PICtoXHQDocumentCenter === 1) {
        if (!(this.job.csr > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.CustomerService')]))
          return
        }
        userId = this.job.csr
      } else if (this.PICtoXHQDocumentCenter === 2) {
        if (!(this.job.dc > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.Documents')]))
          return
        }
        userId = this.job.dc
      } else {
        if (!(this.job.op > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.Operation')]))
          return
        }
        userId = this.job.op
      }
      const contact = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', userId)
      if (contact) {
        phone = contact.cell
        if (!phone) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel'))
        }
      }
      return phone
    },
    async xhqShowOverseasAgentFeedbackDialog() {
      await xhqQueryOverseasAgentFeedback({ cargoDocUuid: this.form.uuid }).then(res => {
        if (res.ok) {
          Object.assign(this.xhqOverseasAgentFeedbackDialog.data, res.data)
          this.xhqOverseasAgentFeedbackDialog.data.jobUuid = this.job.uuid
        }
      })
      this.xhqOverseasAgentFeedbackDialog.callback = this.xhqOverseasAgentFeedbackCallback
      this.xhqOverseasAgentFeedbackDialog.visible = true
    },
    xhqOverseasAgentFeedbackCallback(flg) {
      if (flg) {
        this.form.shipperLine1 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine1
        this.form.shipperLine2 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine2
        this.form.shipperLine3 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine3
        this.form.shipperLine4 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine4
        this.form.shipperLine5 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine5
        this.form.shipperLine6 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine6
        this.form.shipperLine7 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine7
        this.form.consigneeLine1 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine1
        this.form.consigneeLine2 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine2
        this.form.consigneeLine3 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine3
        this.form.consigneeLine4 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine4
        this.form.consigneeLine5 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine5
        this.form.consigneeLine6 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine6
        this.form.consigneeLine7 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine7
        this.form.notifyLine1 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine1
        this.form.notifyLine2 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine2
        this.form.notifyLine3 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine3
        this.form.notifyLine4 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine4
        this.form.notifyLine5 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine5
        this.form.notifyLine6 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine6
        this.form.notifyLine7 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine7
        this.form.loadingPort = this.xhqOverseasAgentFeedbackDialog.data.feedbackLoadingPort
        this.form.dischargingPort = this.xhqOverseasAgentFeedbackDialog.data.feedbackDischargingPort
        this.form.destinationPort = this.xhqOverseasAgentFeedbackDialog.data.feedbackDestinationPort
        this.form.cargoEnglishName = this.xhqOverseasAgentFeedbackDialog.data.feedbackCargoEnglishName
        this.form.mark = this.xhqOverseasAgentFeedbackDialog.data.feedbackMark
      }
    },
    // 对单链接
    onOpenDocLink(type) {
      JobUtils.openDocLink(this.form.uuid, type)
    },
    downloadAttachment(regionWarehouseMappingUuid) {
      JobUtils.downloadPortRequirementAttachment(regionWarehouseMappingUuid)
    },
    handleDateChange() {
      this.isDateRequired = !this.isDateRequired
      if (this.form.agreePayDate) {
        this.form.releaseReview = 1
        this.form.payable = true
      } else {
        this.form.releaseReview = 0
        this.form.payable = false
      }
    },
    isCustomerSelfRelease(val) {
      this.pm.isCustomerSelfRelease(val)
    },
    isCompanySelfRelease(val) {
      this.pm.isCompanySelfRelease(val)
    },
    async refreshInsideQuantityCharge(insideQuantity) {
      if (String(cache.config.get('ToExoSystem')) === 'XYCW') {
        const charges = []
        for (const charge of this.job.charges) {
          if (BillType.MERGE_BILL_TYPE.code === this.job.typeHBL && await ChargeUtils.checkChargeData(charge, ChargeMeasure.INSIDEPIECE_CHARGE_MEASURE.code, this.job)) {
            charges.push(charge)
          }
        }
        if (charges.length > 0) {
          await this.$confirm(this.$t('Message.InsideQuantityChangeToRefreshCostBasedOnCubagePrice'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            for (const charge of charges) {
              charge.quantity = insideQuantity
              if (charge.unitPriceIncludeTax) {
                ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              } else {
                ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              }
            }
            this.context.modifiedData.charges = this.context.modifiedData.charges || []
            mergeArray(this.context.modifiedData.charges, charges)
            this.context.reloadCharge = true
          })
        }
      }
    },
    async refreshWeightCharge(weight) {
      if (String(cache.config.get('ToExoSystem')) === 'XYCW') {
        const charges = []
        for (const charge of this.job.charges) {
          if (BillType.MERGE_BILL_TYPE.code === this.job.typeHBL && await ChargeUtils.checkChargeData(charge, ChargeMeasure.WGT_CHARGE_MEASURE.code, this.job)) {
            charges.push(charge)
          }
        }
        if (charges.length > 0) {
          await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            for (const charge of charges) {
              charge.quantity = weight
              if (charge.unitPriceIncludeTax) {
                ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              } else {
                ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              }
            }
            this.context.modifiedData.charges = this.context.modifiedData.charges || []
            mergeArray(this.context.modifiedData.charges, charges)
            this.context.reloadCharge = true
          })
        }
      }
      ChargeUtils.wgttWeightChargesCanUpdate(this.job, weight, this.context)
      await this.calculateChargeWeight()
    },
    async refreshCubageCharge(cubage) {
      if (String(cache.config.get('ToExoSystem')) === 'XYCW') {
        const charges = []
        for (const charge of this.job.charges) {
          if (BillType.MERGE_BILL_TYPE.code === this.job.typeHBL && await ChargeUtils.checkChargeData(charge, ChargeMeasure.VOL_CHARGE_MEASURE.code, this.job)) {
            charges.push(charge)
          }
        }
        if (charges.length > 0) {
          await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            for (const charge of charges) {
              charge.quantity = cubage
              if (charge.unitPriceIncludeTax) {
                ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              } else {
                ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              }
            }
            this.context.modifiedData.charges = this.context.modifiedData.charges || []
            mergeArray(this.context.modifiedData.charges, charges)
            this.context.reloadCharge = true
          }).catch(() => {
          })
        }
      }
      await this.calculateChargeWeight()
    },
    async refreshChargeWeightCharge(chargeWeight) {
      if (String(cache.config.get('ToExoSystem')) === 'XYCW') {
        const charges = []
        for (const charge of this.job.charges) {
          if (BillType.MERGE_BILL_TYPE.code === this.job.typeHBL && await ChargeUtils.checkChargeData(charge, ChargeMeasure.WGTX_CHARGE_MEASURE.code, this.job)) {
            charges.push(charge)
          }
        }
        if (charges.length > 0) {
          this.$confirm(this.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            for (const charge of charges) {
              charge.quantity = chargeWeight
              if (charge.unitPriceIncludeTax) {
                ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              } else {
                ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              }
            }
            this.context.modifiedData.charges = this.context.modifiedData.charges || []
            mergeArray(this.context.modifiedData.charges, charges)
            this.context.reloadCharge = true
          })
        }
      }
    },
    async calculateChargeWeight() {
      const oldChargeWeight = this.form.chargeWeight
      CargoDocUtil.calculateSEChargeWeight(this.form)
      if (oldChargeWeight !== this.form.chargeWeight) {
        await this.refreshChargeWeightCharge(this.form.chargeWeight)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.triggers{
  .operat-wrap{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .el-checkbox{
      margin-right: 15px;
      &:first-of-type{
        margin-left: 20px;
      }
    }
  }
}
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>
<style>
.messageIndex{
  z-index:99999 !important;
}
</style>
